<template>
    <v-btn block color="blue white--text text-capitalize subtitle-1 text-align-left" @click="signUpWithFb">
        <v-icon dark left>mdi-facebook</v-icon> Login using facebook
    </v-btn>
</template>
<script>
import { SIGN_UP_USER_OTHERS } from "@/store/actions.type"
export default {
    methods: {
        signUpWithFb() {
            this.$store.dispatch(SIGN_UP_USER_OTHERS, {
                type: 'facebook'
            })
        }
    }
}
</script>